import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '产品中心',
    links: [
      { name: 'DRAM 芯片', path: '/category' },
      { name: '内存模组', path: '/category' },
      { name: '嵌入式存储', path: '/category' },
      { name: '解决方案', path: '/category' },
    ],
  },
  {
    title: '新闻资讯',
    links: [
      { name: '企业动态', path: '/articles' },
      { name: '行业洞察', path: '/articles' },
      { name: '媒体报道', path: '/articles' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '集团介绍', path: '/about' },
      { name: '发展历程', path: '/about' },
      { name: '企业荣誉', path: '/about' },
      { name: '联系我们', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12 md:py-16">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                尊
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                尊龙集团
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              一体化存储器制造企业
              <br />
              专注于DRAM芯片的设计、研发、生产与销售
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-primary-500 transition-colors text-background-100 text-sm" aria-label="微信">
                <i className="ri-wechat-line" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-primary-500 transition-colors text-background-100 text-sm" aria-label="微博">
                <i className="ri-weibo-line" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-primary-500 transition-colors text-background-100 text-sm" aria-label="LinkedIn">
                <i className="ri-linkedin-line" />
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-700/20 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 尊龙半导体科技有限公司 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">备案号：皖ICP备2025XXXXXX号</a>
          </div>
        </div>
      </div>
    </footer>
  );
}